import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconGoogleimages(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1H1c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM5.5 3C6.4 3 7 3.6 7 4.5S6.4 6 5.5 6 4 5.4 4 4.5 4.6 3 5.5 3zM2 12l2-4 3 2 3-4 4 6H2z"
      />
    </Icon>
  )
}
